import React from 'react'
import styled from 'styled-components'
import ErrorMessage from '../../blocks/ErrorMessage'

export default function Input({
  icon,
  register,
  error = '',
  label,
  showErrorMessage = true,
  testId,
  ...props
}) {
  return (
    <StyledInput>
      {/* <div>
        <i className={"icon icon-" + icon} />
      </div> */}
      <input
        type='text'
        placeholder={label}
        data-testid={testId || `input-${props.name || 'default'}`}
        {...props}
      />
      {error && showErrorMessage && (
        <ErrorMessage data-testid={`error-${props.name || 'default'}`}>
          {error}
        </ErrorMessage>
      )}
    </StyledInput>
  )
}

const StyledInput = styled.div`
  padding: 12.5px 27px;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 25px;
  border-radius: 5px;
  margin-bottom: 10px;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;

    & > i {
      background-color: var(--dark);
      width: 26px;
      height: 26px;
    }
  }

  & > input {
    letter-spacing: -0.61px;
    border: none;
    outline: none;
    width: 100%;
    padding: 7.5px 0;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 30px;

    color: #acacac;
  }
`
